"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var storedValuesDidChange = function storedValuesDidChange(prevStoredValues, storedValues) {
  var valueChanged = false;

  if (Object.keys(prevStoredValues).length !== Object.keys(storedValues).length) {
    return true;
  }

  Object.keys(prevStoredValues).map(function (valueKey) {
    var previousStoredValues = prevStoredValues[valueKey];
    var currentStoredValues = storedValues[valueKey];

    if (currentStoredValues && previousStoredValues.value !== currentStoredValues.value) {
      valueChanged = true;
    }

    return false;
  });
  return valueChanged;
};

var _default = storedValuesDidChange;
exports["default"] = _default;